import Cookies from 'js-cookie';

const baseURL = process.env.REACT_APP_VENDING_API_URL;

// Vending UI (menu + routes) is only shown when the integration-api vending
// endpoint is configured for this build. Unset = hidden (e.g. prod before go-live).
export const isVendingEnabled = Boolean(baseURL);

export default async function vendingApiClient(endpoint: string, options: RequestInit = {}) {
  if (!baseURL) {
    throw new Error('REACT_APP_VENDING_API_URL is not configured');
  }

  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  const url = `${baseURL.replace(/\/$/, '')}${path}`;
  const token = Cookies.get('token');

  const response = await fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    let message = `Request failed (${response.status})`;
    try {
      const body = await response.json();
      if (body?.error) message = body.error;
    } catch {
      // ignore parse errors
    }
    throw new Error(message);
  }

  return response;
}
